





























































































































































import Vue, { PropType } from "vue";
import { Select, Option } from "element-ui";
import HttpClientFactory from "../../../../services/HttpClientFactory";
import { ValidationObserver } from "vee-validate";
import HttpClient from "../../../../services/HttpClient";
import FaceDeliveryData from "../../../../types/receivers/deliveryTypes/faceReceiver/FaceDeliveryData";
import FaceB2BDeliveryData from "../../../../types/receivers/deliveryTypes/faceb2bReceiver/FaceB2BDeliveryData";
import { snakeCase } from "lodash";

interface DeliveryTypeSelectorOption {
  value: string;
  label: string;
}

export default Vue.extend({
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  props: {
    receiverId: {
      type: String as PropType<string | null>,
    },
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      showFACe: false,
      showFACeB2B: false,
      face: {
        managingBody: "",
        processingUnit: "",
        accountingOffice: "",
      } as FaceDeliveryData,
      faceB2B: {
        dire: "",
      } as FaceB2BDeliveryData,
      selects: {
        selectedOption: "choose_later" as string,
        options: [
          {
            value: "choose_later",
            label: "receiver:create.choose_later",
          },
          { value: "FACe", label: "receiver:create.face" },
          { value: "FACeB2B", label: "receiver:create.faceb2b" },
        ] as DeliveryTypeSelectorOption[],
      },
    };
  },
  computed: {
    getReceiverId(): string | null {
      return this.receiverId;
    },
  },
  methods: {
    validate: async function () {
      if (this.$refs.FACe != undefined) {
        const isValid = await (
          this.$refs.FACe as InstanceType<typeof ValidationObserver>
        ).validate();
        if (isValid) {
          try {
            await this.httpClient.post(
              process.env.VUE_APP_BACKEND_ENDPOINT +
                "/receivers/v1/" +
                this.receiverId +
                "/add-face",
              this.face
            );
            const succes: any = {
              text: this.$t("receiver:saved"),
              type: "success",
            };
            this.$notify(succes);
            setTimeout(() => this.$router.push("view"), 2000);
          } catch (e) {
            const arrayOfErrors: any[] = e.response.data.errors;
            arrayOfErrors.forEach((error: any) => {
              this.showValidationError(
                snakeCase(error.field),
                snakeCase(error.rule)
              );
            });
          }
        }
        return;
      }
      if (this.$refs.FACeB2B != undefined) {
        const isValid = await (
          this.$refs.FACeB2B as InstanceType<typeof ValidationObserver>
        ).validate();
        if (isValid) {
          try {
            await this.httpClient.post(
              process.env.VUE_APP_BACKEND_ENDPOINT +
                `/receivers/v1/${this.receiverId}/add-face-b2b`,
              this.faceB2B
            );
            const succes: any = {
              text: this.$t("receiver:saved"),
              type: "success",
            };
            this.$notify(succes);
            setTimeout(() => this.$router.push("view"), 2000);
          } catch (e) {
            const error: any = {
              text: this.$t("receiver:error"),
              type: "error",
            };
            this.$notify(error);
          }
        }
        return;
      }
      this.$router.push("view");
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("receiver:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
    cascade: function (e: string) {
      if (e === "FACe") {
        this.showFACe = true;
        this.showFACeB2B = false;
      }
      if (e === "FACeB2B") {
        this.showFACeB2B = true;
        this.showFACe = false;
      }
      if (e === "choose_later") {
        this.showFACeB2B = false;
        this.showFACe = false;
      }
    },
  },
});
